export const BronzeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="77"
    height="72"
    viewBox="0 0 77 72"
    fill="none"
  >
    <g clip-path="url(#clip0_1595_7653)">
      <path
        d="M61.898 71.9951L38.45 58.1088L15.1125 72L22.5 44.9468L0.648773 27.5048L28.2102 25.4467L38.4976 0L49.2924 24.8944L76.3512 27.4958L55.1201 44.9957L61.898 71.9951Z"
        fill="#E8A0A3"
      />
      <g style={{ mixBlendMode: "multiply" }}>
        <path
          d="M61.898 71.9951L38.45 58.1088L15.1125 72L22.5 44.9468L0.648773 27.5048L28.2102 25.4467L38.4976 0L49.2924 24.8944L76.3512 27.4958L55.1201 44.9957L61.898 71.9951Z"
          fill="#E3AB97"
        />
      </g>
      <path
        style={{ mixBlendMode: "multiply" }}
        opacity="0.5"
        d="M38.5008 39.7989L55.1199 44.9961L76.351 27.4961L38.5008 39.7989Z"
        fill="url(#paint0_linear_1595_7653)"
      />
      <g style={{ mixBlendMode: "multiply" }} opacity="0.1">
        <path
          d="M38.5008 39.7989L55.1199 44.9961L76.351 27.4961L38.5008 39.7989Z"
          fill="#603913"
        />
      </g>
      <path
        style={{ mixBlendMode: "screen" }}
        opacity="0.3"
        d="M76.3512 27.4957L49.2924 24.8943L38.5011 39.7985L76.3512 27.4957Z"
        fill="url(#paint1_linear_1595_7653)"
      />
      <g style={{ mixBlendMode: "screen" }} opacity="0.2">
        <path
          d="M76.3512 27.4957L49.2924 24.8943L38.5011 39.7985L76.3512 27.4957Z"
          fill="#FDE594"
        />
      </g>
      <path
        style={{ mixBlendMode: "multiply" }}
        opacity="0.52"
        d="M38.501 39.7977L0.648773 27.5039L22.5 44.9458L38.501 39.7977Z"
        fill="url(#paint2_linear_1595_7653)"
      />
      <g style={{ mixBlendMode: "multiply" }} opacity="0.2">
        <path
          d="M38.501 39.7977L0.648773 27.5039L22.5 44.9458L38.501 39.7977Z"
          fill="#603913"
        />
      </g>
      <path
        style={{ mixBlendMode: "multiply" }}
        opacity="0.52"
        d="M38.5011 39.7988L38.45 58.1091L61.898 71.9953L38.5011 39.7988Z"
        fill="url(#paint3_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "multiply" }}
        opacity="0.45"
        d="M15.1126 72.0002L38.4501 58.1091L38.5012 39.7988L15.1126 72.0002Z"
        fill="url(#paint4_linear_1595_7653)"
      />
      <g style={{ mixBlendMode: "multiply" }} opacity="0.4">
        <path
          d="M15.1126 72.0002L38.4501 58.1091L38.5012 39.7988L15.1126 72.0002Z"
          fill="#603913"
        />
      </g>
      <path
        style={{ mixBlendMode: "screen" }}
        opacity="0.3"
        d="M38.5011 39.7986L49.2924 24.8944L38.4976 0L38.5011 39.7986Z"
        fill="url(#paint5_linear_1595_7653)"
      />
      <g style={{ mixBlendMode: "screen" }} opacity="0.3">
        <path
          d="M38.5011 39.7986L49.2924 24.8944L38.4976 0L38.5011 39.7986Z"
          fill="#FDE594"
        />
      </g>
      <path
        style={{ mixBlendMode: "screen" }}
        opacity="0.52"
        d="M38.5008 39.7988L61.8977 71.9953L55.1199 44.996L38.5008 39.7988Z"
        fill="url(#paint6_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "multiply" }}
        opacity="0.52"
        d="M38.501 39.7986L38.4975 0L28.2102 25.4467L38.501 39.7986Z"
        fill="url(#paint7_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "screen" }}
        opacity="0.3"
        d="M28.2102 25.4473L0.648773 27.5054L38.501 39.7992L28.2102 25.4473Z"
        fill="url(#paint8_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "multiply" }}
        opacity="0.45"
        d="M38.5012 39.7988L22.5001 44.947L15.1126 72.0002L38.5012 39.7988Z"
        fill="url(#paint9_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "screen" }}
        d="M49.3409 24.9037L49.2926 24.8946L49.2668 24.8457L38.4237 39.7793L38.5803 39.8352L49.3409 24.9037Z"
        fill="url(#paint10_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "screen" }}
        d="M38.441 39.7578L15.1378 71.8061L15.1126 71.9991L15.2378 71.9376L38.5641 39.8193L38.441 39.7578Z"
        fill="url(#paint11_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "screen" }}
        d="M22.4475 44.8929L22.5 44.9467L22.4888 45.0306L38.5024 39.8684L38.4976 39.7461L22.4475 44.8929Z"
        fill="url(#paint12_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "screen" }}
        d="M76.2322 27.4766L38.4974 39.7214L38.5037 39.8542L76.2798 27.5716L76.3511 27.4961L76.2322 27.4766Z"
        fill="url(#paint13_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "screen" }}
        d="M0.843823 27.4707L0.648773 27.505L0.762727 27.6238L38.4682 39.8476L38.5339 39.7561L0.843823 27.4707Z"
        fill="url(#paint14_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "screen" }}
        d="M55.1579 44.9565L38.5339 39.7559L38.4682 39.8474L55.1306 45.0558L55.1201 44.9956L55.1579 44.9565Z"
        fill="url(#paint15_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "screen" }}
        d="M38.4681 39.8105L38.3856 58.1383L38.4499 58.1082L38.5107 58.1362L38.5639 39.8196L38.4681 39.8105Z"
        fill="url(#paint16_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "screen" }}
        d="M38.5437 0.0859898L38.4962 0L38.4535 0.0859898L38.4682 39.8475L38.5661 39.779L38.5437 0.0859898Z"
        fill="url(#paint17_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "screen" }}
        d="M28.2438 25.3865L28.2102 25.4466L28.1396 25.4585L38.4682 39.8474L38.5612 39.7062L28.2438 25.3865Z"
        fill="url(#paint18_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "screen" }}
        d="M61.8972 71.8539L38.5611 39.707L38.4681 39.8482L61.7664 71.9315L61.8979 71.9958L61.8972 71.8539Z"
        fill="url(#paint19_linear_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "color-dodge" }}
        opacity="0.15"
        d="M39.5098 39.8533C39.5147 51.3109 39.0142 58.0936 38.4563 58.0936C37.8984 58.0936 37.4964 51.3109 37.4901 39.8554C37.4852 28.3978 37.9306 19.1081 38.4891 19.1074C39.0463 19.1074 39.5042 28.3957 39.5105 39.8533H39.5098Z"
        fill="url(#paint20_radial_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "color-dodge" }}
        opacity="0.15"
        d="M39.3169 39.2611C46.0458 48.5347 51.1374 56.3172 50.6858 56.6457C50.2341 56.9722 44.4113 49.7211 37.6824 40.4482C30.9515 31.176 27.8069 25.8782 28.2599 25.551C28.7101 25.2231 32.5853 29.9903 39.3169 39.2618V39.2611Z"
        fill="url(#paint21_radial_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "color-dodge" }}
        opacity="0.15"
        d="M39.3155 40.4493C32.5657 49.7069 26.7288 56.9461 26.2786 56.6182C25.827 56.2889 30.9332 48.5177 37.6838 39.2588C44.4336 29.9998 48.8296 24.6999 49.2805 25.0278C49.7315 25.3564 46.0667 31.1911 39.3162 40.4493H39.3155Z"
        fill="url(#paint22_radial_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "color-dodge" }}
        opacity="0.15"
        d="M38.8142 40.815C27.9222 44.3748 22.7481 45.5451 22.5755 45.0159C22.4014 44.4853 27.2958 42.4565 38.1858 38.8953C49.075 35.3326 58.0445 32.8788 58.22 33.4073C58.3926 33.9372 49.7035 37.2545 38.8142 40.815Z"
        fill="url(#paint23_radial_1595_7653)"
      />
      <path
        style={{ mixBlendMode: "color-dodge" }}
        opacity="0.15"
        d="M38.1876 40.8161C27.2858 37.2954 18.5854 34.0103 18.7567 33.479C18.928 32.949 27.9066 35.3728 38.8105 38.8921C49.7123 42.4142 55.2346 44.4647 55.0633 44.9953C54.892 45.5259 49.0915 44.3367 38.1876 40.8161Z"
        fill="url(#paint24_radial_1595_7653)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1595_7653"
        x1="76.8583"
        y1="25.1314"
        x2="43.9241"
        y2="44.0553"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.27" stop-color="#AAAAAA" />
        <stop offset="0.54" stop-color="#616161" />
        <stop offset="0.75" stop-color="#2C2C2C" />
        <stop offset="0.91" stop-color="#0C0C0C" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1595_7653"
        x1="62.3199"
        y1="26.4792"
        x2="41.5414"
        y2="38.2144"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.09" stop-color="#F2F2F2" />
        <stop offset="0.26" stop-color="#CFCFCF" />
        <stop offset="0.48" stop-color="#989898" />
        <stop offset="0.75" stop-color="#4C4C4C" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1595_7653"
        x1="0.840918"
        y1="36.4569"
        x2="38.4075"
        y2="35.6438"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1595_7653"
        x1="46.6562"
        y1="47.7322"
        x2="49.815"
        y2="63.3107"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1595_7653"
        x1="37.5248"
        y1="45.1237"
        x2="21.9896"
        y2="73.9307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1595_7653"
        x1="45.4749"
        y1="29.6591"
        x2="38.0692"
        y2="19.3031"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="0.25" stop-color="#4C4C4C" />
        <stop offset="0.52" stop-color="#989898" />
        <stop offset="0.74" stop-color="#CFCFCF" />
        <stop offset="0.91" stop-color="#F2F2F2" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1595_7653"
        x1="49.6177"
        y1="56.1803"
        x2="58.4149"
        y2="51.8698"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1595_7653"
        x1="28.0924"
        y1="20.1261"
        x2="38.9267"
        y2="19.8915"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1595_7653"
        x1="0.773186"
        y1="33.3293"
        x2="38.3398"
        y2="32.5161"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="0.25" stop-color="#4C4C4C" />
        <stop offset="0.52" stop-color="#989898" />
        <stop offset="0.74" stop-color="#CFCFCF" />
        <stop offset="0.91" stop-color="#F2F2F2" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1595_7653"
        x1="31.0371"
        y1="41.0287"
        x2="20.3285"
        y2="67.6795"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1595_7653"
        x1="38.4956"
        y1="39.8338"
        x2="49.1769"
        y2="24.9697"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_1595_7653"
        x1="15.6044"
        y1="71.4322"
        x2="38.388"
        y2="39.7762"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_1595_7653"
        x1="22.7396"
        y1="44.8771"
        x2="38.7813"
        y2="39.6979"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_1595_7653"
        x1="38.0668"
        y1="39.6816"
        x2="76.5369"
        y2="27.6921"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_1595_7653"
        x1="0.626324"
        y1="34.0711"
        x2="57.9282"
        y2="32.8308"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_1595_7653"
        x1="38.8593"
        y1="39.7815"
        x2="55.1447"
        y2="45.1525"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_1595_7653"
        x1="38.1828"
        y1="48.9805"
        x2="39.4081"
        y2="48.9539"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_1595_7653"
        x1="38.1716"
        y1="39.6349"
        x2="38.8492"
        y2="-0.129605"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_1595_7653"
        x1="28.2945"
        y1="32.7273"
        x2="57.3921"
        y2="32.0975"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_1595_7653"
        x1="27.0206"
        y1="56.3546"
        x2="61.5385"
        y2="55.6074"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <radialGradient
        id="paint20_radial_1595_7653"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(48.0188 38.7079) scale(1.04105 20.1703)"
      >
        <stop stop-color="white" />
        <stop offset="0.08" stop-color="#E3E3E3" />
        <stop offset="0.34" stop-color="#949494" />
        <stop offset="0.57" stop-color="#545454" />
        <stop offset="0.77" stop-color="#262626" />
        <stop offset="0.91" stop-color="#0A0A0A" />
        <stop offset="1" />
      </radialGradient>
      <radialGradient
        id="paint21_radial_1595_7653"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(45.5858 37.0131) rotate(-35.93) scale(1.03272 20.0089)"
      >
        <stop stop-color="white" />
        <stop offset="0.08" stop-color="#E3E3E3" />
        <stop offset="0.34" stop-color="#949494" />
        <stop offset="0.57" stop-color="#545454" />
        <stop offset="0.77" stop-color="#262626" />
        <stop offset="0.91" stop-color="#0A0A0A" />
        <stop offset="1" />
      </radialGradient>
      <radialGradient
        id="paint22_radial_1595_7653"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(43.9137 45.2002) rotate(36.09) scale(1.04166 20.1823)"
      >
        <stop stop-color="white" />
        <stop offset="0.08" stop-color="#E3E3E3" />
        <stop offset="0.34" stop-color="#949494" />
        <stop offset="0.57" stop-color="#545454" />
        <stop offset="0.77" stop-color="#262626" />
        <stop offset="0.91" stop-color="#0A0A0A" />
        <stop offset="1" />
      </radialGradient>
      <radialGradient
        id="paint23_radial_1595_7653"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(41.3956 41.6684) rotate(71.9) scale(1.02231 19.8073)"
      >
        <stop stop-color="white" />
        <stop offset="0.08" stop-color="#E3E3E3" />
        <stop offset="0.34" stop-color="#949494" />
        <stop offset="0.57" stop-color="#545454" />
        <stop offset="0.77" stop-color="#262626" />
        <stop offset="0.91" stop-color="#0A0A0A" />
        <stop offset="1" />
      </radialGradient>
      <radialGradient
        id="paint24_radial_1595_7653"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(38.1342 36.0309) rotate(107.93) scale(1.03003 19.9569)"
      >
        <stop stop-color="white" />
        <stop offset="0.08" stop-color="#E3E3E3" />
        <stop offset="0.34" stop-color="#949494" />
        <stop offset="0.57" stop-color="#545454" />
        <stop offset="0.77" stop-color="#262626" />
        <stop offset="0.91" stop-color="#0A0A0A" />
        <stop offset="1" />
      </radialGradient>
      <clipPath id="clip0_1595_7653">
        <rect
          width="75.7025"
          height="72"
          fill="white"
          transform="translate(0.648773)"
        />
      </clipPath>
    </defs>
  </svg>
);
